import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { creatorApi as n } from "@maat/api-main";
//#region src/creator/useCreatorOverviewQuery.ts
var r = (r) => t({
	queryKey: e.overview(r?.from, r?.to),
	queryFn: () => n.overview(r)
});
//#endregion
export { r as useCreatorOverviewQuery };
